import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { first } from 'rxjs';
import { ChatPreviewService } from '../../../services/chat-preview.service';
import { TutorService } from '../../../services/tutor.service';
import { UsageService } from '../../../services/usage.service';

@Component({
  selector: 'app-chat-preview-dialog',
  templateUrl: './chat-preview-dialog.component.html',
  styleUrl: './chat-preview-dialog.component.scss',
})
export class ChatPreviewDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    protected fb: FormBuilder,
    protected usageService: UsageService,
    protected tutorService: TutorService,
    protected nbToastrService: NbToastrService,
    protected dialogRef: NbDialogRef<ChatPreviewDialogComponent>,
    protected chatPreviewService: ChatPreviewService
  ) {
    this.form = fb.group({
      botId: this.fb.control('', Validators.required),
    });

    this.tutorService.listTutors().subscribe();
    this.usageService.listApiKeys().subscribe();
  }

  ngOnInit(): void {
    this.tutorService.tutors$.pipe(first()).subscribe((tutors) => {
      if (tutors.length > 0) {
        this.form.patchValue({
          botId: tutors[0].id,
        });
      }
    });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }

  async onSubmit() {
    if (this.usageService.apiKeys$.value.length === 0) {
      this.nbToastrService.danger(
        'Bitte erstellen Sie einen API-Schlüssel',
        'Fehler'
      );
    }

    this.chatPreviewService.connect(
      this.usageService.apiKeys$.value[0].clear_api_key,
      this.form.value.botId
    );
    this.dialogRef.close();
  }
}
